module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp2_8023.240c43e3.png";